import { useState } from "react";
import emailjs from "emailjs-com";
import React from "react";
import MapRedirect from "./mapRedirect";
import { useLanguage } from "../context/LanguageContext"; 

const initialState = {
  name: "",
  email: "",
  message: "",
};
export const Contact = (props) => {
  const { switchLanguage } = useLanguage(); 
  const [{ name, email, message }, setState] = useState(initialState);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };
  const clearState = () => setState({ ...initialState });

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_otkg7uj",
        "template_3jkpsmn",
        e.target,
        "u9UKWSW1kOS9sErRd"
      )
      .then(
        (result) => {
          clearState();
        },
        (error) => {
          console.log("error", error.text);
        }
      );
  };
  return (
    <div>
      <div id="contact">
        <div className="container">
          {/* <div className="col-md-8">
            <div className="row">
              <div className="section-title">
                <h2>Get In Touch</h2>
                <p>
                  Please fill out the form below to send us an email and we will
                  get back to you as soon as possible.
                </p>
              </div>
              <form name="sentMessage" validate onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        id="name"
                        name="name"
                        className="form-control"
                        placeholder="Name"
                        required
                        onChange={handleChange}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="email"
                        id="email"
                        name="email"
                        className="form-control"
                        placeholder="Email"
                        required
                        onChange={handleChange}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <textarea
                    name="message"
                    id="message"
                    className="form-control"
                    rows="4"
                    placeholder="Message"
                    required
                    onChange={handleChange}
                  ></textarea>
                  <p className="help-block text-danger"></p>
                </div>
                <div id="success"></div>
                <button type="submit" className="btn btn-custom btn-lg">
                  Send Message
                </button>
              </form>
            </div>
          </div> */}

          <div className="contact-info">
            <div className="contact-item">
              <h3>{props.data ? props.data.title : "loading"}</h3>
            </div>
          </div>
          <div className="col-md-12">
            <div className="row">
              <div className="col-md-4">
                <p>
                  <span>
                    <i className="fa fa-map-marker"></i> : {" "}
                    <MapRedirect
                      text={props.data ? props.data.address : null}
                    />
                  </span>{" "}
                </p>
              </div>
              <div className="col-md-4">
                <p>
                  <span>
                    <i className="fa fa-phone"></i> :
                  </span>{" "}
                  {props.data ? props.data.phone : "loading"}
                </p>
              </div>
              <div className="col-md-4">
                <p>
                  <span>
                    <i className="fa fa-envelope-o"></i> :
                  </span>{" "}
                  {props.data ? props.data.email : "loading"}
                </p>
              </div>
              <div className="social">
                <ul>
                  <li>
                    <a href={props.data ? props.data.facebook : "/"}>
                      <i className="fa fa-facebook"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="footer">
          {/* Language switcher */}
          {/* <div
          style={{
            textAlign: "right",
            padding: "10px",
            position: "absolute",
            top: "10px",
            right: "10px",
            zIndex: 1000,
          }}
        >
          <button onClick={() => switchLanguage("en")}>En</button>
          <button onClick={() => switchLanguage("ar")}>Ar</button>
        </div> */}

        <div className="container text-center">
      
      <button
        onClick={() => switchLanguage("en")}
        className="text-blue-400 underline font-medium hover:text-blue-300 transition duration-200"
      >
        English
      </button>
      <button
        onClick={() => switchLanguage("ar")}
        className="text-pink-400 underline font-medium hover:text-pink-300 transition duration-200"
      >
        العربية
      </button>
   

         
            &copy; 2025 Aminecell. Designed by{" "}
            <a
              href="https://www.linkedin.com/in/nora-bitar-0a91a51b6/"
              rel="nofollow"
            >
              Nora Bitar
            </a>
          
        </div>
      </div>
    </div>
  );
};
